import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import Clinic from "./Models/Clinic"
import ClinicSearchPrice from "./Models/ClinicSearchPrice"
import ClinicSearchOptions from "./Models/ClinicSearchOptions"
import ClinicSearchListType from "./Models/ClinicSearchListType"
import ClinicSearchAdditionalOption from "./Models/ClinicSearchAdditionalOption"
import { AdditionalOption } from "../../components/Administration/ClinicSearchOptions/AdditionalOptions"

export function ClinicGetObservable(clinicSearchListTypeID: number): Observable<Clinic[]> {
  const requestBody: string = new URLSearchParams({
    clinicSearchListTypeID: clinicSearchListTypeID.toString()
  }).toString()

  return ObservableFromFetch<Clinic[]>("WorkforceClinics/GetClinicLists?" + requestBody)
}

export function ClinicSearchPriceSetObservable(list: ClinicSearchPrice[]): Observable<string> {
  var counter = 0;
  const ClinicSearchPriceTiers = list.map((el) => {
    el.SortOrder = ++counter
    return el
  })
  const requestBody: string = JSON.stringify({
    ClinicSearchPriceTiers
  })

  return ObservableFromFetch<string>("WorkforceClinics/SetClinicSearchPrice", requestBody)
}

export function ClinicSearchPriceGetObservable(): Observable<ClinicSearchPrice[]> {
  return ObservableFromFetch<ClinicSearchPrice[]>("WorkforceClinics/GetClinicSearchPrice")
}

export function ClinicSearchOptionsSetObservable(radius1: number, radius2: number, mpSitesOnly: boolean = false): Observable<string> {
  const requestBody: string = JSON.stringify({
    radius1: radius1,
    radius2: radius2,
    mpSitesOnly: mpSitesOnly
  })

  return ObservableFromFetch<string>("WorkforceClinics/SetClinicSearchRadius", requestBody)
}

export function ClinicSearchOptionsGetObservable(): Observable<ClinicSearchOptions> {
  const requestBody: string = JSON.stringify({})

  return ObservableFromFetch<ClinicSearchOptions>("WorkforceClinics/GetClinicSearchRadius", requestBody)
}

export function ClinicSearchListTypesGetObservable(): Observable<ClinicSearchListType[]> {
  return ObservableFromFetch<ClinicSearchListType[]>("WorkforceClinics/GetClinicSearchListType")
}

export function ClinicSearchListRemoveObservable(clinicSearchListTypeID: number, clinicSearchListIDs: number[]): Observable<string> {
  const requestBody: string = JSON.stringify({
    clinicSearchListTypeID: clinicSearchListTypeID,
    clinicSearchListID: clinicSearchListIDs,
    isRemove: true
  })

  return ObservableFromFetch<string>("WorkforceClinics/SetClinicLists", requestBody)
}

export function ClinicSearchListAddObservable(clinicSearchListTypeID: number, code: string, name: string): Observable<string> {
  const requestBody: string = JSON.stringify({
    clinicSearchListTypeID: clinicSearchListTypeID,
    code: code,
    name: name
  })

  return ObservableFromFetch<string>("WorkforceClinics/SetClinicLists", requestBody)
}

export function ClinicSearchPriceForSiteSearchGetObservable(): Observable<ClinicSearchPrice[]> {
  return ObservableFromFetch<ClinicSearchPrice[]>("WorkforceClinics/GetClinicSearchPriceForSiteSearch")
}

export function ClinicSearchAdditionalOptionsGetObservable(): Observable<ClinicSearchAdditionalOption[]> {
  return ObservableFromFetch<ClinicSearchAdditionalOption[]>("WorkforceClinics/GetClinicSearchOptions")
}

export function ClinicSearchAdditionalOptionsSetObservable(options: AdditionalOption[]): Observable<string> {
  const requestBody: string = JSON.stringify(
    options
  )
  return ObservableFromFetch<string>("WorkforceClinics/SetClinicSearchOptions", requestBody)
}

interface OwnedSitesData {
  UsePrimarySitesOnly: boolean
  Clinics: Clinic[]
}

export function RetrieveOwnedSitesObservable() {
  const requestBody: string = JSON.stringify({})

  return ObservableFromFetch<OwnedSitesData>("WorkforceClinics/RetrieveOwnedSites", requestBody)
}

export function UpdateOwnedSitesObservable(data: OwnedSitesData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("WorkforceClinics/UpdateOwnedSites", requestBody)
}
